function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M115.8,189.2l-43.4,86v47.4h-30v-46.8L0,189.2h34.3l21.4,49.8c0.3,0.9,1.4,4.6,3.1,10.8h0.3c0.9-4.5,1.7-7.9,2.9-10.5 l21.8-50.1L115.8,189.2L115.8,189.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M233.7,322.7h-32.8l-9.4-29.7h-47.4l-9.4,29.7h-32.6l48.6-133.3h35.7L233.7,322.7z M184.6,269.8L170.4,225 c-1-3.4-1.7-7.4-2.2-12h-0.7c-0.3,3.9-1,7.7-2.4,11.7l-14.6,45.1H184.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M402.4,322.7h-29.7v-79.8c0-8.6,0.3-18.2,1.2-28.5h-0.7c-1.5,8.2-2.9,14.1-4.1,17.7l-31.2,90.6h-24.5l-31.7-89.7 c-0.9-2.4-2.2-8.6-4.1-18.5h-0.9c0.9,13.2,1.2,24.7,1.2,34.7v73.8h-27.1V189.5h43.9l27.3,79.1c2.2,6.3,3.8,12.7,4.8,19h0.5 c1.7-7.4,3.4-13.7,5.3-19.2l27.3-78.9h42.9v133.1H402.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512,322.7h-79.4V189.3h30v109H512V322.7z"
}));

function SvgYaml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYaml);
export default __webpack_public_path__ + "static/media/yaml.6e32980b.svg";
export { ForwardRef as ReactComponent };